module.exports = __webpack_public_path__ + "media/application/images/2018/2018-search-2c436ffe7e8ad36fd9ecc8ddd78d2cc4.svg";